<template>
  <v-container fluid full-height grid-list-md>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">">
              <template slot="item" slot-scope="props">
                <router-link
                  :to="'/' + props.item.to"
                  :disabled="props.item.disabled"
                  v-bind:class="{
                    'v-breadcrumbs__item v-breadcrumbs__item--disabled':
                      props.item.disabled,
                  }"
                  >{{ props.item.text }}</router-link
                >
              </template>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <v-btn outline color="primary" @click="goBack">
              Go Back
              <v-icon right>arrow_back</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <v-flex>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex>
                <v-menu
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="issueDate"
                    label="Issue Date"
                    prepend-icon="event"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="issueDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="serialNo"
                  label="Serial No"
                  v-model="locationMovement.serialNo"
                  type="text"
                  :rules="rules.serialNoRules(255, 'Serial No')"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-autocomplete
                  v-model="locationMovement.fromWarehouseId"
                  :items="activeWarehouseList"
                  :hide-no-data="true"
                  color="blue-grey lighten-2"
                  label="From Warehouse"
                  item-text="name"
                  item-value="id"
                  menu-props="auto"
                  :readonly="
                    user.role.roleName == 'WAREHOUSE_MANAGER' ||
                      user.role.roleName == 'BRANCH_ADMIN' ||
                      user.role.roleName == 'WAREHOUSE_STAFF' ||
                      user.role.roleName == 'PRODUCTION_MANAGER' ||
                      user.role.roleName == 'ASSET_MANAGER'
                  "
                  @change="changeWarehouse()"
                ></v-autocomplete>
              </v-flex>
              <v-flex sm6>
                <v-autocomplete
                  v-model="locationMovement.fromBinId"
                  :items="binList"
                  :hide-no-data="true"
                  color="blue-grey lighten-2"
                  label="From Bin"
                  item-text="name"
                  item-value="id"
                  menu-props="auto"
                  :rules="rules.fromBinRules"
                  v-on:change="changeBin()"
                ></v-autocomplete>
                <h3
                  v-if="isError"
                  style="color: #ff5252; font: 12px Roboto, sans-serif"
                >
                  {{ error }}
                </h3>
              </v-flex>
              <v-flex sm6>
                <v-autocomplete
                  v-model="locationMovement.toBinId"
                  :items="binList"
                  :hide-no-data="true"
                  color="blue-grey lighten-2"
                  label="To bin"
                  item-text="name"
                  item-value="id"
                  menu-props="auto"
                  :rules="rules.toBinRules"
                  v-on:change="checkSameBin()"
                ></v-autocomplete>
                <h3
                  v-if="isError"
                  style="color: #ff5252; font: 12px Roboto, sans-serif"
                >
                  {{ error }}
                </h3>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="referenceNo"
                  placeholder="Reference No"
                  v-model="combinedRef"
                  color="warning"
                  clearable
                  append-icon="search"
                  @click:clear="clearPOAndEMR()"
                  @click:append="
                    showPOAndEMRListDialog = !showPOAndEMRListDialog
                  "
                  :disabled="
                    !locationMovement.fromWarehouseId ||
                      !locationMovement.fromBinId
                  "
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="description"
                  label="Description"
                  v-model="locationMovement.description"
                  type="text"
                  :rules="rules.descriptionRules"
                ></v-text-field>
              </v-flex>
              <v-flex>
                <v-layout row wrap>
                  <v-btn
                    color="success"
                    @click="addLocationMovementDetailItem()"
                    :disabled="locationMovement.referenceNo ? true : false"
                  >
                    Add Item
                    <v-icon right>add</v-icon>
                  </v-btn>
                  <v-flex xs6 ml-4>
                    <v-text-field
                      name="scanBarcode"
                      label="Scan barcode....."
                      v-model="scanBarcode"
                      type="text"
                      v-on:keyup.enter="trigger(scanBarcode)"
                      prepend-icon="filter_center_focus"
                      :disabled="locationMovement.referenceNo ? true : false"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row class="light--text">
                  <v-flex xs2>Code</v-flex>
                  <v-flex xs3>Name</v-flex>
                  <v-flex xs2>Unit</v-flex>
                  <v-flex xs1>Qty</v-flex>
                  <v-flex xs3>QC No</v-flex>
                  <v-flex xs2>Batch No</v-flex>
                  <v-flex xs3 class="text-xs-center">MFG Date</v-flex>
                  <v-flex xs3 class="text-xs-center">EXP Date</v-flex>
                  <v-flex xs2>Remark</v-flex>
                  <v-flex xs1>Action</v-flex>
                </v-layout>
                <v-layout
                  row
                  v-for="(locationMovementDetail,
                  index) in locationMovement.locationMovementDetailItems"
                  :key="index"
                >
                  <v-flex xs2>
                    <v-text-field
                      placeholder="Select the code"
                      v-model="locationMovementDetail.productCode"
                      @click.stop="showProducts(), (selectedIndex = index)"
                      :rules="rules.codeRules"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs3>
                    <v-text-field
                      v-model="locationMovementDetail.productName"
                      :hide-no-data="true"
                      color="blue-grey lighten-2"
                      placeholder="Name"
                      readonly
                      :rules="rules.productNameRules"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs2>
                    <v-autocomplete
                      v-model="locationMovementDetail.factorUnitName"
                      :items="locationMovementDetail.productUnits"
                      :hide-no-data="true"
                      color="blue-grey lighten-2"
                      item-value="factorUnitName"
                      item-text="factorUnitName"
                      menu-props="auto"
                      placeholder="Select"
                      @change="(option) => changeFactorUnit(option, index)"
                      :rules="rules.unitRules"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs1>
                    <v-text-field
                      v-model="locationMovementDetail.qty"
                      min="0"
                      :rules="rules.qtyRules"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs3>
                    <v-autocomplete
                      v-model="locationMovementDetail.qcNo"
                      :hide-no-data="true"
                      :items="locationMovementDetail.stockQcNoDTOList"
                      item-text="qcNo"
                      item-value="qcNo"
                      color="blue-grey lighten-2"
                      menu-props="auto"
                      :readonly="locationMovementDetail.id ? true : false"
                      @change="getQcBatchNoList(locationMovementDetail)"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs2>
                    <v-autocomplete
                      v-model="locationMovementDetail.batchNo"
                      :hide-no-data="true"
                      :items="locationMovementDetail.batchNoList"
                      item-text="batchNo"
                      item-value="batchNo"
                      color="blue-grey lighten-2"
                      menu-props="auto"
                      :readonly="locationMovementDetail.id ? true : false"
                      @change="getBatchDate(locationMovementDetail)"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs3>
                    <v-menu
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                      :disabled="locationMovementDetail.id ? true : false"
                    >
                      <v-text-field
                        slot="activator"
                        placeholder="MFG Date"
                        type="text"
                        prepend-icon="event"
                        v-model="locationMovementDetail.mfgDate"
                        readonly
                        clearable
                        @click:clear="locationMovementDetail.mfgDate = ''"
                      ></v-text-field>
                      <v-date-picker
                        v-model="locationMovementDetail.mfgDate"
                      ></v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs3>
                    <v-menu
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                      :disabled="locationMovementDetail.id ? true : false"
                    >
                      <v-text-field
                        slot="activator"
                        placeholder="EXP Date"
                        type="text"
                        prepend-icon="event"
                        v-model="locationMovementDetail.expDate"
                        readonly
                        clearable
                        @click:clear="locationMovementDetail.expDate = ''"
                      ></v-text-field>
                      <v-date-picker
                        v-model="locationMovementDetail.expDate"
                      ></v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs2>
                    <v-text-field
                      name="remark"
                      placeholder="Remark"
                      v-model="locationMovementDetail.remark"
                      type="text"
                      :rules="rules.remarkRules"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs1>
                    <v-btn
                      class="mx-0"
                      icon
                      @click="
                        removeLocationMovementDetailItem(
                          index,
                          locationMovementDetail.id
                        )
                      "
                      :disabled="index == 0"
                    >
                      <v-icon>cancel</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex sm12>
                <div class="text-xs-center">
                  <v-btn color="error" @click="clear">
                    Reset
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn
                    color="primary"
                    :loading="saveLoading"
                    @click="onSave"
                    :disabled="saveLoading || !valid"
                  >
                    Save
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>

    <!-- Product list dialog -->
    <v-dialog v-model="showProductListDialog" scrollable max-width="1000px">
      <v-card>
        <v-card-title>
          <!-- Search Section -->
          <v-layout wrap>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="code"
                label="Code"
                type="text"
                class="mr-1"
                v-model="queryParams.code"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="name"
                label="Name"
                type="text"
                class="mr-1"
                v-model="queryParams.name"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="brandName"
                label="Brand"
                type="text"
                class="mr-1"
                v-model="queryParams.brandName"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="categoryName"
                label="Category"
                type="text"
                class="mr-1"
                v-model="queryParams.categoryName"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="productGroupName"
                label="Product Group"
                type="text"
                class="mr-1"
                v-model="queryParams.productGroupName"
              ></v-text-field>
            </v-flex>
            <v-flex sm2>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <!-- Product List Section -->
          <v-flex xs12 class="mt-1">
            <v-card>
              <v-data-table
                :headers="headers"
                :items="productList"
                class="elevation-1"
                :loading="showListLoading"
                :total-items="totalRows"
                :rows-per-page-items="rowsPerPageItems"
                :pagination.sync="pagination"
                :must-sort="true"
              >
                <template slot="items" slot-scope="props">
                  <td
                    @click="
                      setProduct(props.item.code, selectedIndex),
                        (showProductListDialog = !showProductListDialog)
                    "
                  >
                    <a>{{ props.item.code }}</a>
                  </td>
                  <td>{{ props.item.name }}</td>
                  <td>{{ props.item.brand.name }}</td>
                  <td>{{ props.item.category.name }}</td>
                  <td v-if="props.item.productGroup">
                    {{ props.item.productGroup.name }}
                  </td>
                  <td v-else></td>
                  <td>{{ props.item.description }}</td>
                </template>
              </v-data-table>
            </v-card>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- final message dialog -->
    <v-dialog
      v-model="messageDialogBox"
      max-width="500px"
      @keydown.enter="messageDialogBox = false"
    >
      <v-card>
        <v-card-text>
          <v-flex>
            <v-alert type="error" :value="true">
              <h3>{{ responseError }}</h3>
            </v-alert>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" flat @click="messageDialogBox = false"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <POAndEMRListDialog
      :showDialog="showPOAndEMRListDialog"
      :params="{
        fromDate: currentDate,
        toDate: currentDate,
        warehouseId: locationMovement.fromWarehouseId,
        binId: locationMovement.fromBinId,
        status: 'CONFIRM',
        type: 'PRODUCTION_ORDER',
      }"
      @close="closePOAndEMRDialog"
    ></POAndEMRListDialog>
  </v-container>
</template>

<script>
import { LocationMovement, LocationMovementDetail } from "../../models/model";
import { commonService } from "../../services/common-service";
import { warehouseService } from "../../services/warehouse-service";
import { LocationMovementFormRules } from "../../helpers/validation-rules";
import { productService } from "../../services/product-service";
import { locationMovementService } from "../../services/location-movement-service";
import { stockService } from "../../services/stock-service";
import POAndEMRListDialog from "../location-movement/ProductionOrderEMRDialog";

export default {
  components: { POAndEMRListDialog },
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    breadcrumbs: [
      {
        text: "Location Movement",
        disabled: false,
        to: "location-movements",
      },
      {
        text: "Location Movement Detail",
        disabled: true,
      },
    ],
    showPOAndEMRListDialog: false,
    selectedIndex: 0,
    valid: true,
    isError: false,
    showListLoading: false,
    showProductListDialog: false,
    saveLoading: false,
    messageDialogBox: false,
    totalRows: 0,
    currentDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
    issueDate: "",
    fromWarehouseId: "",
    responseError: "",
    activeWarehouseList: [],
    tempWarehouseList: [],
    binList: [],
    productList: [],
    locationMovement: new LocationMovement(),
    locationMovementDetail: new LocationMovementDetail(),
    rules: new LocationMovementFormRules(),
    queryParams: {
      name: "",
      code: "",
      status: "ACTIVE",
      brandName: "",
      categoryName: "",
      productGroupName: "",
      isPurchase: true,
    },
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      sortBy: "code",
      totalItems: 0,
    },
    rowsPerPageItems: [10, 50, 100],
    headers: [
      { text: "Code", value: "code" },
      { text: "Name", align: "left", value: "name" },
      { text: "Brand", value: "brand.name" },
      { text: "Category", value: "category.name" },
      { text: "Product Group", value: "productGroup.name" },
      { text: "Description", value: "description" },
    ],
    scanBarcode: "",
  }),
  created() {
    if (
      this.user.roleName == "WAREHOUSE_MANAGER" ||
      this.user.roleName == "BRANCH_ADMIN" ||
      this.user.roleName == "WAREHOUSE_STAFF"
    ) {
      this.locationMovement.fromWarehouseId = this.user.warehouseId;
      this.warehouseId = this.user.warehouseId;
      if (this.user.roleName == "WAREHOUSE_STAFF") {
        this.binList = this.user.selectedBinList;
      }
    } else if (
      this.user.roleName == "PRODUCTION_MANAGER" ||
      this.user.role.roleName == "ASSET_MANAGER"
    ) {
      this.locationMovement.fromWarehouseId = this.user.shop.warehouseId;
      this.warehouseId = this.user.shop.warehouseId;
    }
    this.getActiveWarehouses();

    const id = this.$route.params.id;
    if (id == "new") {
      // new location movement
      this.issueDate = commonService.formatDate(
        new Date().toISOString().substring(0, 10),
        "YYYY-MM-DD"
      );
      this.addLocationMovementDetailItem();
    }
  },
  computed: {
    combinedRef: {
      get() {
        return this.locationMovement.referenceNo
          ? this.locationMovement.referenceNo +
              "/" +
              this.locationMovement.refNo
          : "";
      },
    },
  },
  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.getProductList();
    },

    getWarehouseList() {
      var fromWarehouse;
      var toWarehouse;
      var tempList = [];
      if (!this.tempWarehouseList.includes(fromWarehouse)) {
        this.tempWarehouseList.push(fromWarehouse);
        tempList.push(this.locationMovement.fromWarehouse);
      }
      toWarehouse = this.locationMovement.toWarehouse.name;
      if (!this.tempWarehouseList.includes(toWarehouse)) {
        this.tempWarehouseList.push(toWarehouse);
        tempList.push(this.locationMovement.toWarehouse);
      }
      for (var j = 0; j < this.activeWarehouseList; j++) {
        var temp = this.activeWarehouseList[j].name;
        if (!this.tempWarehouseList.includes(temp)) {
          this.tempWarehouseList.push(temp);
          tempList.push(this.activeWarehouseList[j]);
        }
      }
      this.activeWarehouseList = tempList;
    },
    getActiveWarehouses() {
      warehouseService
        .getWarehousesByStatus("ACTIVE")
        .then((res) => {
          this.activeWarehouseList = res.data;
        })
        .catch((err) => {
          console.log(err);
          if (err.response.data) {
            this.responseError = err.response.data.message;
          }
        })
        .finally(() => {
          if (
            this.user.roleName == "WAREHOUSE_MANAGER" ||
            this.user.roleName == "BRANCH_ADMIN"
          )
            this.getBinByWarehouse(this.user.warehouseId);
          if (
            this.user.role.roleName == "PRODUCTION_MANAGER" ||
            this.user.role.roleName == "ASSET_MANAGER"
          )
            this.getBinByWarehouse(this.user.shop.warehouseId);
        });
    },
    getBinByWarehouse(warehouseId) {
      let warehouse = commonService.search(
        "id",
        warehouseId,
        this.activeWarehouseList
      );
      this.binList = warehouse.binList;
    },
    addLocationMovementDetailItem() {
      // deep copy
      let locationMovement = JSON.parse(
        JSON.stringify(this.locationMovementDetail)
      );
      this.locationMovement.locationMovementDetailItems.push(locationMovement);
    },
    removeLocationMovementDetailItem(index, locationMovementDetailItemId) {
      if (locationMovementDetailItemId) {
        // add delete locationMovement item id
        if (!this.locationMovement.deleteLocationMovementDetailItemIds) {
          this.locationMovement.deleteLocationMovementDetailItemIds = [];
        }
        this.locationMovement.deleteLocationMovementDetailItemIds.push(
          locationMovementDetailItemId
        );
      }
      this.$delete(this.locationMovement.locationMovementDetailItems, index);
    },

    checkSameBin() {
      if (this.locationMovement.toBinId == this.locationMovement.fromBinId) {
        this.isError = true;
        this.error = "To and From Bin must be different.";
      } else {
        this.isError = false;
      }
    },
    showProducts() {
      if (
        this.locationMovement.fromWarehouseId &&
        this.locationMovement.fromBinId
      ) {
        // Clean query params
        if (this.locationMovement.referenceNo) {
          this.showProductListDialog = !this.showProductListDialog;
        }
        this.queryParams.code = "";
        this.queryParams.name = "";
        this.queryParams.brandName = "";
        this.queryParams.categoryName = "";
        this.queryParams.productGroupName = "";
        this.getProductList().then(
          (this.showProductListDialog = !this.showProductListDialog)
        );
      } else {
        this.messageDialogBox = true;
        if (!this.locationMovement.fromWarehouseId) {
          this.responseError = "Please select from warehouse.";
        } else if (!this.locationMovement.fromBinId) {
          this.responseError = "Please select from bin.";
        }
      }
    },
    getProductList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      return productService
        .getProductList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.productList = res.data.productList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    setProduct(code, index) {
      let product = commonService.search("code", code, this.productList);
      this.locationMovement.locationMovementDetailItems[index].productId =
        product.id;
      this.locationMovement.locationMovementDetailItems[index].productCode =
        product.code;
      this.locationMovement.locationMovementDetailItems[index].productName =
        product.name;
      // set default unit
      var j = "";
      for (var i = 0; i < product.productUnits.length; i++) {
        if (product.productUnits[i].basicUnit == true) j = i;
      }
      this.locationMovement.locationMovementDetailItems[index].productUnitId =
        product.productUnits[j].id;
      this.locationMovement.locationMovementDetailItems[index].factorUnitName =
        product.productUnits[j].factorUnitName;
      this.locationMovement.locationMovementDetailItems[index].productUnits =
        product.productUnits;
      this.getProductQcBatchDateList(
        this.locationMovement.locationMovementDetailItems[index]
      );
      this.locationMovement.locationMovementDetailItems[index].qty = 0;
      this.locationMovement.locationMovementDetailItems[index].remark = "";
      this.clearQCno(this.locationMovement.locationMovementDetailItems[index]);
    },
    getProductQcBatchDateList(locationMovementDetail) {
      locationMovementDetail.qcNo = "";
      locationMovementDetail.batchNo = "";
      locationMovementDetail.mfgDate = "";
      locationMovementDetail.expDate = "";
      let params = {
        warehouseId: this.locationMovement.fromWarehouseId,
        binId: this.locationMovement.fromBinId,
        productId: locationMovementDetail.productId,
        balanceType: "WITH_BALANCE",
      };
      return stockService
        .getStockQcBatchDateList(params)
        .then((res) => {
          locationMovementDetail.stockQcNoDTOList = res.data;
          this.getQcBatchNoList(locationMovementDetail);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getQcBatchNoList(locationMovementDetail) {
      locationMovementDetail.batchNo = "";
      locationMovementDetail.mfgDate = "";
      locationMovementDetail.expDate = "";
      let qc = locationMovementDetail.stockQcNoDTOList.find(
        (v) => v.qcNo == locationMovementDetail.qcNo
      );
      if (qc) {
        locationMovementDetail.batchNoList = qc.batchNoList;
        this.getBatchDate(locationMovementDetail);
      }
    },
    getBatchDate(locationMovementDetail) {
      locationMovementDetail.mfgDate = "";
      locationMovementDetail.expDate = "";
      let batchNo = locationMovementDetail.batchNoList.find(
        (v) => v.batchNo == locationMovementDetail.batchNo
      );
      if (batchNo) {
        let batchDate = batchNo.qcBatchDateDTOList.find(
          (v) => v.batchNo == locationMovementDetail.batchNo
        );
        if (batchDate) {
          locationMovementDetail.mfgDate = batchDate.mfgDate;
          locationMovementDetail.expDate = batchDate.expDate;
        }
      }
    },
    changeWarehouse() {
      this.locationMovement.fromBinId = "";
      this.locationMovement.toBinId = "";
      this.locationMovement.referenceNo = "";
      this.locationMovement.locationMovementDetailItems = [];
      this.addLocationMovementDetailItem();
      this.getBinByWarehouse(this.locationMovement.fromWarehouseId);
    },
    changeBin() {
      this.locationMovement.referenceNo = "";
      this.locationMovement.locationMovementDetailItems = [];
      this.addLocationMovementDetailItem();
      this.checkSameBin();
    },
    onSave() {
      if (this.$refs.form.validate()) {
        if (!this.saveLoading) {
          this.saveLoading = true;
          // convert to millisecond
          this.locationMovement.issueDateInMilliSeconds = commonService.convertToMilliseconds(
            this.issueDate
          );

          this.locationMovement.locationMovementDetailItems.forEach(
            (locationMovementDetail) => {
              if (locationMovementDetail.mfgDate) {
                locationMovementDetail.mfgDateInMilliSeconds = commonService.convertToMilliseconds(
                  locationMovementDetail.mfgDate
                );
              }
              if (locationMovementDetail.expDate) {
                locationMovementDetail.expDateInMilliSeconds = commonService.convertToMilliseconds(
                  locationMovementDetail.expDate
                );
              }
            }
          );

          locationMovementService
            .saveLocationMovement(this.locationMovement)
            .then((res) => {
              console.log(res);
              this.goBack();
            })
            .catch((err) => {
              console.log(err);
              if (err.response.data) {
                this.responseError = err.response.data.message;
                this.messageDialogBox = true;
              }
              this.saveLoading = false;
            });
        }
      }
    },

    clear() {
      this.$refs.form.resetValidation();
      if (!this.locationMovement.id) {
        this.locationMovement = new LocationMovement();
        this.locationMovement.fromWarehouseId = this.user.warehouseId;
        this.addLocationMovementDetailItem();
      }
    },

    goBack() {
      this.$router.go(-1);
    },

    trigger(barcode) {
      if (barcode) {
        this.getProductUnitByBarcode(barcode);
      }
    },
    getProductUnitByBarcode(bcode) {
      let params = {
        barcode: bcode,
      };
      productService
        .getProductUnitByBarcode(params)
        .then((res) => {
          let productUnit = res.data;
          if (productUnit) {
            this.setProductByBarcode(productUnit);
          }
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.scanBarcode = "";
        });
    },

    setProductByBarcode(productUnit) {
      if (
        this.locationMovement.locationMovementDetailItems[0].productCode == ""
      ) {
        // if the first locationMovement item is empty init object
        this.addValuesToFirstDetailItem(productUnit);
      } else if (this.isItemExist(productUnit)) {
        this.addQtyToExistingDetailItem(productUnit);
      } else {
        this.addNewItemToDetailItemList(productUnit);
      }
    },
    addQtyToExistingDetailItem(productUnit) {
      this.locationMovement.locationMovementDetailItems.forEach((item) => {
        if (item.productUnitId === productUnit.id) {
          item.qty = Math.abs(item.qty) + 1;
        }
      });
    },
    isItemExist(productUnit) {
      for (let item of this.locationMovement.locationMovementDetailItems) {
        if (item.productUnitId === productUnit.id) {
          return true;
        }
      }
    },
    addValuesToFirstDetailItem(productUnit) {
      this.locationMovement.locationMovementDetailItems[0].productId =
        productUnit.product.id; // productId
      this.locationMovement.locationMovementDetailItems[0].productUnitId =
        productUnit.id; // productUnitId
      this.locationMovement.locationMovementDetailItems[0].productCode =
        productUnit.product.code; // productCode
      this.locationMovement.locationMovementDetailItems[0].productName =
        productUnit.product.name; // productName
      this.locationMovement.locationMovementDetailItems[0].productUnits.push(
        productUnit
      ); // productUnits[]
      this.locationMovement.locationMovementDetailItems[0].factorUnitName =
        productUnit.factorUnitName; // factorUnitName
      this.locationMovement.locationMovementDetailItems[0].qty = 1; // qty
    },
    addNewItemToDetailItemList(productUnit) {
      // get new init Detail Item
      let locationMovementDetailItem = JSON.parse(
        JSON.stringify(this.locationMovementDetail)
      );

      locationMovementDetailItem.productId = productUnit.product.id; // productId
      locationMovementDetailItem.productUnitId = productUnit.id; // productUnitId
      locationMovementDetailItem.productCode = productUnit.product.code; // productCode
      locationMovementDetailItem.productName = productUnit.product.name; // productName
      locationMovementDetailItem.productUnits[0] = productUnit; // productUnits[]
      locationMovementDetailItem.factorUnitName = productUnit.factorUnitName; // factorUnitName
      locationMovementDetailItem.qty = 1; // qty

      this.locationMovement.locationMovementDetailItems.push(
        locationMovementDetailItem
      );
    },
    changeFactorUnit(factorUnitName, index) {
      let productUnit = commonService.search(
        "factorUnitName",
        factorUnitName,
        this.locationMovement.locationMovementDetailItems[index].productUnits
      );
      if (this.checkItemDuplicate(productUnit, index)) {
        let item = productUnit.product.name + " (" + factorUnitName + ")";
        this.responseError =
          "Location Movement Item: " + item + " is duplicated";
        this.messageDialogBox = true;
      }
      this.locationMovement.locationMovementDetailItems[index].productUnitId =
        productUnit.id;
    },
    checkItemDuplicate(productUnit, index) {
      for (let item in this.locationMovement.locationMovementDetailItems) {
        if (item != index) {
          if (
            this.locationMovement.locationMovementDetailItems[item]
              .productUnitId === productUnit.id
          ) {
            return true;
          }
        }
      }
    },
    clearQCno(locationMovementDetail) {
      locationMovementDetail.qcNo = "";
      locationMovementDetail.batchNo = "";
      locationMovementDetail.mfgDate = "";
      locationMovementDetail.mfgDateInMilliSeconds = "";
      locationMovementDetail.expDate = "";
      locationMovementDetail.expDateInMilliSeconds = "";
    },
    closePOAndEMRDialog(referenceNoObj) {
      this.showPOAndEMRListDialog = !this.showPOAndEMRListDialog;
      if (!(JSON.stringify(referenceNoObj) === "{}")) {
        this.locationMovement.referenceNo = referenceNoObj.issueNo;
        this.locationMovement.refNo = referenceNoObj.referenceNo;
        this.locationMovement.locationMovementDetailItems =
          referenceNoObj.locationMovementDetailList;
      }
    },
    clearPOAndEMR() {
      this.locationMovement.referenceNo = "";
      this.locationMovement.locationMovementDetailItems = [];
      this.addLocationMovementDetailItem();
    },
  },
};
</script>
